/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

export default function getHCConfigPropertyKey(formattingOptions :any, key :string) {

    const advancedProperties = formattingOptions.advancedProperties || {};

    if (Array.isArray(advancedProperties)) {
        const property = advancedProperties.find((setting) => (setting.name === key));
        if (property) {
            return property.value;
        }
    } else if (typeof advancedProperties === 'object') {
        if (typeof advancedProperties[key] !== 'undefined') {
            return advancedProperties[key];
        }
    }

    return null;
}
